import appAndPages from './app-and-pages'
import dashboard from './dashboard'

// Array of sections
export default [...dashboard, ...appAndPages]
